import type {ModelHubRoute} from 'model-hub/modelHubRoutes';

export const MODEL_HUB_EVENT_PAYLOADS = {
  MODEL_HUB_CLEAR_ROUTE: {} as {},
  MODEL_HUB_SET_ROUTE: {} as {
    route: ModelHubRoute;
  },
} as const;

export type ModelHubEventPayload = typeof MODEL_HUB_EVENT_PAYLOADS;
